import { styled } from 'styled-components';

import { AppStoreBadge } from '~/src/common/components/AppBadges/AppStoreBadge';
import { GooglePlayBadge } from '~/src/common/components/AppBadges/GooglePlayBadge';
import { media } from '~/src/styles-constants';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};
  padding: 16px;
  gap: 8px;

  ${media.M`
    flex-direction: row;
    justify-content: space-between;
    border-radius: 8px;
    padding: 8px;
    margin: 72px 0;
  `}
`;

const IMAGE_WIDTH = 140;
const LEFT_PADDING = 56;

export const ImageAndInformations = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  > img {
    height: 170px;
  }

  ${media.M`
    position: relative;
    padding-left: ${LEFT_PADDING + IMAGE_WIDTH}px;

    > img {
      position: absolute;
      left: ${LEFT_PADDING}px;
      width: ${IMAGE_WIDTH}px;
      height: initial;
      top: -48px;
    }
  `}

  ${media.XXXXL`
    > img {
      top: -68px;
    }
  `}
`;

export const Informations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${media.M`
    padding-left: 20px;
  `}

  ${media.XXXXL`
    flex-direction: row;
    gap: 40px;
    align-items: center;
  `}
`;

export const TitleAndRating = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.quaternary};
  font-weight: 700;
  font-size: 32px;
  text-transform: uppercase;
  line-height: 32px;
`;

export const Rating = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Stars = styled.div`
  display: flex;
`;

export const RatingLabel = styled.div`
  color: ${({ theme }) => theme.palette.text};
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
`;

export const Description = styled.div`
  font-size: 12px;
  max-width: 376px;

  ${media.M`
    font-size: 14px;
  `}
`;

export const QRCode = styled.img`
  display: none;
  width: 215px;
  height: 136px;

  ${media.L`
    display: block;
  `}
`;

export const Stores = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-left: 0;

  ${media.M`
    flex-direction: column;
  `}

  ${media.XXL`
    flex-direction: row;
  `}
`;

export const AppStore = styled(AppStoreBadge)`
  display: block;
  width: 100%;

  ${media.XS`
    height: 54px;
    width: 180px;
  `}
`;

export const GooglePlay = styled(GooglePlayBadge)`
  display: block;
  width: 100%;

  ${media.XS`
    height: 54px;
    width: 180px;
  `}
`;
